import { create } from 'zustand'

interface ModalRetrievePropertyState {
  modalRetrieveProperty: {
    isOpen: boolean
    propertyId: string
    onSuccess?: () => void
  }
  setModalRetrieveProperty: (modalRetrieveProperty: {
    isOpen: boolean
    propertyId: string
    onSuccess?: () => void
  }) => void
  reset: () => void
}

const initialState = {
  modalRetrieveProperty: {
    isOpen: false,
    propertyId: '',
    title: ''
  }
}

export const useModalRetrievePropertyStore =
  create<ModalRetrievePropertyState>()((set) => ({
    ...initialState,
    setModalRetrieveProperty: (modalRetrieveProperty) =>
      set({ modalRetrieveProperty }),
    reset: () =>
      set({
        modalRetrieveProperty: initialState.modalRetrieveProperty
      })
  }))
